import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    documentoNumero: '',
    apellido: '',
    nombre: '',
    // fechaNacimiento: '1900-01-01',
    // fechaNacimientoHabilitada: false,
    prefijo: '',
    celular: '',
    paisId: 0,
    pais: null,
    email: '',
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_STAFF' (state, staffId) {
        state.id = staffId;
        state.documentoNumero = '';
        state.apellido = '';
        state.nombre = '';
        // state.fechaNacimiento = '1900-01-01';
        // state.fechaNacimientoHabilitada = false;
        state.prefijo = '';
        state.celular = '';
        state.paisId = 0;
        state.pais = null;
        state.email = '';
        state.rowVersion = null;
    },
    'SET_STAFF' (state, staff) {
        state.documentoNumero = staff.documentoNumero.trim();
        state.apellido = staff.apellido.trim();
        state.nombre = staff.nombre.trim();
        // state.fechaNacimiento = moment(staff.fechaNacimiento).format('YYYY-MM-DD');
        // if (moment(state.fechaNacimiento).format('YYYY-MM-DD') != '1900-01-01') {
        //     state.fechaNacimientoHabilitada = true;
        // } else {
        //     state.fechaNacimientoHabilitada = false;   
        // }
        state.prefijo = staff.prefijo.trim();
        state.celular = staff.celular.trim();
        state.paisId = staff.paisId;
        state.pais = staff.pais;
        state.email = staff.email.trim();
        state.rowVersion = staff.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, staffId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_STAFF', staffId);

            let getStaff = false;
            if (staffId) {
                if (staffId != 0) {
                    getStaff = true;
                }
            }

            if (getStaff) {
                apiAxios.get('staff/' + staffId + '/ABM') 
                    .then(res => {
                        commit('SET_STAFF', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                // let fechaNacimiento = '1900-01-01';
                // if ((/true/i).test(state.fechaNacimientoHabilitada)) {
                //     fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
                // }

                let staff= {
                    documentoNumero: state.documentoNumero,
                    apellido: state.apellido.toUpperCase().trim(),
                    nombre: state.nombre.toUpperCase().trim(),
                    // fechaNacimiento: fechaNacimiento,
                    prefijo: state.prefijo.trim(),
                    celular: state.celular.trim(),
                    email: state.email.trim(),
                };

                let url = 'staff';
                if (state.id) {
                    if (state.id != 0) {
                        url += '/' + state.id;
                        staff.rowVersion = state.rowVersion;
                    }
                }

                apiAxios.post(url, staff)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}